import Vue from 'vue';
import gtm from '@/utils/gtm';

function sendEvent(eventGA) {
  if (process.env.NODE_ENV === 'production') {
    Vue.ga.event(eventGA);
  }
}

function sendDepositEvent(eventGA, eventGTM) {
  const isStaging = window.location.href.includes('engine-stg');

  if (isStaging) {
    return;
  }

  if (process.env.NODE_ENV === 'production') {
    Vue.$ga.event({
      eventCategory: 'transaction',
      eventAction: 'deposit',
      ...eventGA,
    });
    Vue.prototype.$gtm.trackEvent({
      category: 'transaction',
      action: 'deposit',
      ...eventGTM,
    });
  }
}

const gtmProvider = {
  sendEvent,
  sendDepositEvent,
};

Vue.prototype.$gtmProvider = gtmProvider;
